import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Order'],
  endpoints: (builder) => ({
    getOrders: builder.query<unknown[], void>({
      query: () => 'orders',
      providesTags: ['Order'],
    }),
    getOrder: builder.query<unknown, string>({
      query: (id) => `orders/${id}`,
      providesTags: ['Order'],
    }),
    createOrder: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'orders', method: 'POST', body }),
      invalidatesTags: ['Order'],
    }),
    updateOrder: builder.mutation<unknown, { id: string; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({ url: `orders/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Order'],
    }),
    deleteOrder: builder.mutation<void, string>({
      query: (id) => ({ url: `orders/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Order'],
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useGetOrderQuery,
  useCreateOrderMutation,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
} = orderApi;
